import { Outlet, useParams } from "react-router-dom";
import { useSectionNavLinks } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function AuditLogLayout() {
  const { sectionId } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const navLinks = useSectionNavLinks(sectionId);

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && (
        <Breadcrumb
          compactOnly
          compactTitle="Audit Log"
          backLink={{ to: "/sections/:sectionId", params: { sectionId } }}
        />
      )}
      <Outlet />
    </AppLayout>
  );
}
